import classNames from 'classnames'
import React from 'react'
import { RatioData } from 'src/shared/ratios.dto'

import * as styles from './spotlight.module.scss'

export interface Props {
  data: RatioData
}

export const Spotlight: React.FC<Props> = ({ data }) => {
  const { value, percentile } = data
  const parsedValue = value ? parseFloat(value) : 0

  return (
    <span className={styles.spotlight}>
      <span className={classNames({ 'stk-text-danger': parsedValue < 0 })}>
        {value || 'n/a'}
      </span>
      <SpotlightIcon value={percentile} className={styles.spotlight__icon} />
    </span>
  )
}

interface SpotlightIconProps {
  value: number | null
  className?: string
}

const SpotlightIcon: React.FC<SpotlightIconProps> = ({
  className = '',
  value,
}) => {
  return (
    <span
      className={classNames(
        'stk-lotto stk-lotto--xs',
        getSpotlightColor(value),
        className,
      )}
    />
  )
}

function getSpotlightColor(val: number | null): string {
  let color: string = ''

  if (val === null) {
    color = 'stk-lotto--neutral'
  } else {
    switch (true) {
      case 80 <= val:
        color = 'stk-lotto--super-green'
        break
      case 60 <= val:
        color = 'stk-lotto--strong-green'
        break
      case 40 <= val:
        color = 'stk-lotto--warm-yellow'
        break
      case 20 <= val:
        color = 'stk-lotto--amber'
        break
      default:
        color = 'stk-lotto--sucker-red'
        break
    }
  }

  return color
}
